import React from "react";

export const RobotFont = ({...props}) => {
  return <span className={props.className} style={{fontFamily:`roboto-${props.type}`}}>{`${props.children} `}</span>;
};
